import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import './index.css';
import App from './App';
import { getMsalInstance } from './auth/authConfig';

if (process.env.NODE_ENV === 'development') {
  import('@axe-core/react').then(({ default: axe }) => {
    axe(React, ReactDOM, 1000);
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// msal-browser v5 requires initialize() to resolve before any other MSAL call —
// BrowserUtils.blockAPICallsBeforeInitialize throws otherwise.
async function initializeMsalAndRender() {
  const msal = getMsalInstance();
  await msal.initialize();

  // Reattach the previously active account (sessionStorage cache) so the app doesn't
  // start every reload as anonymous when a session already exists.
  const existingAccounts = msal.getAllAccounts();
  if (existingAccounts.length > 0) {
    msal.setActiveAccount(existingAccounts[0]);
  }

  // Redirect flow: completes the round-trip back from Entra ID when present, no-ops on a
  // normal (non-redirect) load.
  const redirectResult = await msal.handleRedirectPromise();
  if (redirectResult?.account) {
    msal.setActiveAccount(redirectResult.account);
  }

  renderApp();
}

// REACT_APP_SKIP_AUTH=true (local dev only — the deploy script never sets it) renders without
// MSAL: the lazy getters would otherwise demand Entra values a local build does not have.
const skipAuth = process.env.REACT_APP_SKIP_AUTH === 'true';

if (skipAuth) {
  renderApp();
} else {
  // Why the catch renders instead of rethrowing: an initialize()/handleRedirectPromise()
  // rejection (Entra outage, blocked storage, malformed redirect response) would otherwise
  // leave a permanent white screen — root.render() only ever reached on the success path.
  // Render a visible failure state so it's diagnosable from the UI, not just devtools.
  initializeMsalAndRender().catch(err => {
    console.error('MSAL init failed', err);
    root.render(
      <React.StrictMode>
        <div role="alert" style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
          Anmeldung konnte nicht initialisiert werden. Bitte laden Sie die Seite neu.
        </div>
      </React.StrictMode>
    );
  });
}
